/**
 * Audio & Call control helpers for ACS Call object
 */

const isEmptyObject = (v) =>
  v == null || typeof v !== "object" || Array.isArray(v) || Object.keys(v).length === 0;

export const muteCall = async (call, upsertCallMap, upsertTransferCallMap, childLeg) => {
  if (!call || !call.acsCall) return;
  try {
    if (!isEmptyObject(childLeg) && !childLeg?.isHold) {
      //only when child leg is there and in resumed mode, mute it else mute parent call irrespective of hold state
      await childLeg.acsCall.mute();
      upsertTransferCallMap(childLeg.id, { isMuted: true });
    } else {
      await call.acsCall.mute();
      upsertCallMap(call.id, { isMuted: true });
    }
  } catch (e) {
    console.error("Failed to mute:", e);
  }
};

export const unmuteCall = async (call, upsertCallMap, upsertTransferCallMap, childLeg) => {
  if (!call || !call.acsCall) return;
  try {
    if (!isEmptyObject(childLeg) && !childLeg?.isHold) {
      //only when child leg is there and in resumed mode, unmute it else unmute parent call irrespective of hold state
      await childLeg.acsCall.unmute();
      upsertTransferCallMap(childLeg.id, { isMuted: false });
    } else {
      await call.acsCall.unmute();
      upsertCallMap(call.id, { isMuted: false });
    }
  } catch (e) {
    console.error("Failed to unmute:", e);
  }
};

export const holdCall = async (call, upsertCallMap, upsertTransferCallMap) => {
  if (!call || !call.acsCall) return;
  try {
    if (call?.parentCallId) {
      //transfer leg
      upsertTransferCallMap(call.id, { isHold: true, holdedAt: Date.now() }); //do it at top else callstate changes first
      await call.acsCall.hold();
    } else {
      upsertCallMap(call.id, { isHold: true, holdedAt: Date.now() }); //do it at top else callstate changes first
      await call.acsCall.hold();
    }
  } catch (e) {
    console.error("Failed to hold call:", e);
  }
};

export const resumeCall = async (
  call,
  upsertCallMap,
  upsertTransferCallMap,
  parentCall,
  childCall,
) => {
  if (!call || !call.acsCall) return;
  try {
    const holdDurTotalNew = call.holdDurationTotal + (Date.now() - call.holdedAt);

    if (call?.parentCallId) {
      //transfer leg
      await call.acsCall.resume();
      upsertTransferCallMap(call.id, {
        isHold: false,
        holdDurationTotal: holdDurTotalNew,
        holdedAt: null,
      }); //do it at top else callstate changes first

      //toggle state of parent leg
      if (parentCall && !parentCall.isHold) {
        await holdCall(parentCall, upsertCallMap, upsertTransferCallMap);
      }
    } else {
      //toggle state of child leg
      if (childCall && !childCall.isHold) {
        await holdCall(childCall, upsertCallMap, upsertTransferCallMap);
      }
      await call.acsCall.resume();
      upsertCallMap(call.id, {
        isHold: false,
        holdDurationTotal: holdDurTotalNew,
        holdedAt: null,
      });
    }
  } catch (e) {
    console.error("Failed to resume call:", e);
  }
};
